import { useEffect } from 'react'
import { usePermissions } from '@/hooks/usePermissions'
import { useWidgetKeys } from '@/hooks/useWidgetKeys'
import { env } from '@/lib/env'

/**
 * Embeds the organization's own chat widget into the dashboard so users can
 * test their configured agent. Renders nothing itself — the widget loader
 * injects its own iframe into document.body.
 */
export function OwnWidgetEmbed() {
  const { hasPermission } = usePermissions()

  if (!hasPermission('widget_key:view')) {
    return null
  }

  return <OwnWidgetEmbedInner />
}

function OwnWidgetEmbedInner() {
  const { data: widgetKeys } = useWidgetKeys()
  const activeKey = widgetKeys?.items.find((widget) => widget.is_active)?.key

  useEffect(() => {
    if (!activeKey) return
    // Guard against double-injection (StrictMode re-runs effects in dev)
    if (document.querySelector('script[data-widget-key]')) return
    void import('@/widget/embed').then(({ embedWidget }) =>
      embedWidget({ key: activeKey, apiBase: env.API_BASE_URL })
    )
  }, [activeKey])

  return null
}
